/* eslint-disable import/no-duplicates */
/* eslint-disable no-console */
import React from 'react';

import { GoogleAds, Plus, Sync, Search } from '@profitfy/pakkun-icons';
import { useTheme } from 'styled-components/macro';
import { useGoogleLogin } from '@react-oauth/google';
import { formatDistanceToNow } from 'date-fns';
import pt from 'date-fns/locale/pt-BR';

import { ETextSize } from '@domain/enums/components/EText';
import { ESynchronizationType } from '@domain/enums/hooks/ESynchronization';
import { useGoogleCredentials } from '@helpers/hooks/common/integrations/marketing/google/useGoogleCredentials';
import { useSynchronization } from '@helpers/hooks/common/useSynchronization';
import { useDate } from '@helpers/hooks/useDate';
import { useDebounce } from '@helpers/hooks/useDebounce';

import * as S from './styles';

const Header: React.FC = () => {
  const theme = useTheme();

  const [lastTimeUpdated] = React.useState<Date>(new Date());
  const [, setUpdatedDate] = React.useState<Date>(new Date());

  const { utcToZonedTime } = useDate();
  const { syncAllAdSenseAccounts, handleLogin, handleAdAccountSearchName } = useGoogleCredentials();
  const { currentSynchronizations } = useSynchronization();

  const [adAccountSearchName, setAdAccountSearchName] = React.useState<string>('');

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: response => {
      handleLogin(response);
    },
    onError: response => console.log(response),
    flow: 'auth-code',
    scope:
      'openid https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/adwords',
  });

  const onSearchInputChange = React.useCallback(event => {
    setAdAccountSearchName(event.target.value);
  }, []);

  const isSyncing = Boolean(
    currentSynchronizations?.synchronizations.find(synchronization => {
      if (
        synchronization.type === ESynchronizationType.AD_SENSE_ACCOUNTS ||
        synchronization.type === ESynchronizationType.AD_SENSE_CAMPAIGNS
      ) {
        return true;
      }

      return false;
    }),
  );

  const debouncedAdAccountSearchName = useDebounce(adAccountSearchName, 700);

  React.useEffect(() => {
    handleAdAccountSearchName(debouncedAdAccountSearchName);
  }, [handleAdAccountSearchName, debouncedAdAccountSearchName]);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setUpdatedDate(new Date());
    }, 60000);

    return () => clearInterval(interval);
  }, [lastTimeUpdated]);

  return (
    <S.Wrapper>
      <S.HeadingWrapper>
        <S.Heading>Integração com o Google Ads</S.Heading>
        <S.Text size={ETextSize.B5}>
          Conecte perfis do Google para contabilizar seus gastos com anúncios.
        </S.Text>
      </S.HeadingWrapper>

      <S.Body>
        <S.AddNewProfileButton onClick={handleGoogleLogin}>
          <GoogleAds size={22} />
          Adicionar perfil do Google Ads
          <S.VerticalRule />
          <Plus size={20} color={theme.colors.gray[1]} />
        </S.AddNewProfileButton>

        <S.SyncAndInputWrapper>
          <S.LastUpdatedText size={ETextSize.B5}>
            Atualizado há <br />
            {`${formatDistanceToNow(utcToZonedTime(lastTimeUpdated), {
              locale: pt,
            })}`}
          </S.LastUpdatedText>

          <S.SyncDataButton onClick={syncAllAdSenseAccounts} disabled={isSyncing}>
            <Sync size={17} color={theme.colors.gray[1]} />
          </S.SyncDataButton>

          <S.Input
            type="text"
            prepend={() => <Search size={20} color={theme.colors.gray[3]} />}
            onChange={onSearchInputChange}
          />
        </S.SyncAndInputWrapper>
      </S.Body>
    </S.Wrapper>
  );
};

export default Header;
